<template>
  <v-row justify="center" class="mx-xl-6 mx-lg-6 mx-md-6" no-gutters v-if="_order">
    <v-col xl="9" lg="11" md="12" sm="12" cols="12">
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
        <v-col class="pr-xl-3 pr-lg-3 pr-md-3" xl="8" lg="8" md="8" sm="12" cols="12">
          <v-card class="mx-auto" outlined>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="section-title px-2">Pedido</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-left py-0 px-0">
              <v-list-item class="text-left mx-2" flat>
                <v-list-item-content two-line>
                  <v-list-item-title class="subtitle-2">
                    <span class="font-weight-bold">Orden</span>
                    <span>&nbsp;{{ _order.order_number }}</span>
                  </v-list-item-title>
                  <v-list-item-title class="subtitle-2">Comprado el {{ dateFormat(_order.creation_date, 'D MMM YYYY') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
            <div v-if="$vuetify.breakpoint.xsOnly">
              <v-divider></v-divider>
              <v-toolbar flat dense color="#F9F9F9">
                <v-toolbar-title class="section-title">Pago</v-toolbar-title>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="text-left py-0 px-0">
                <v-list-item class="text-left mx-1" flat>
                  <v-list-item-avatar>
                    <v-icon class="blue" dark>
                      mdi-credit-card
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content three-line>
                    <v-row no-gutters class="px-4 py-2">
                      <v-col class="grey--text text--darken-3 font-weight-bold pb-1" cols="12">
                        {{ getOrderCost }}
                      </v-col>
                      <v-col class="date-approved grey--text text--darken-3 pb-1" cols="12" v-if="_order.payment.date_approved">
                        Aprobado el {{ dateFormat(_order.payment.date_approved, 'D MMM YYYY') }}
                      </v-col>
                      <v-col :class="'payment-' + _order.payment.status" cols="12">
                        {{ getPaymentStatus(_order.payment.status) }}
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
                <v-row no-gutters class="px-4 pb-5" v-if="statusCanRetryPayment(_order.payment.status)">
                  <v-col cols="12">
                    <v-btn class="text-none" block height="42" color="blue darken-1" elevation="0" dark @click="retry(_order)" >
                      Reintentar pago
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
            <v-divider></v-divider>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="section-title px-2">Envío</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-left py-0 px-0">
              <v-list-item class="text-left mx-2" flat>
                <v-list-item-content three-line>
                  <v-list-item-title class="subtitle-2">
                    <span class="font-weight-bold">Recibe:</span>
                    <span>&nbsp;{{ _order.user.first_name }} {{ _order.user.last_name }}</span>
                  </v-list-item-title>
                  <v-list-item-title class="subtitle-2">{{ _order.address.city.name }}, {{ _order.address.region.name }}</v-list-item-title>
                  <v-list-item-subtitle class="subtitle-2">
                    <span>{{ _order.address.address }}</span>
                    <span v-if="_order.address.additional_address"> {{ _order.address.additional_address }},</span>
                    <span> {{ _order.address.neighborhood }}</span>
                    <div class="mt-2" >
                      <a class="shipment-detail-link" @click="shipmentDetail(_order)">
                        Detalle del envío
                      </a>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <div class="border-top">
                <v-list-item class="text-left mx-2" flat>
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2">
                      {{getDeliveryTypeName(_order.delivery.delivery_type)}}
                      <span class="green--text text--darken-2 font-weight-bold" v-if="_order.delivery.cost === 0">&nbsp;Gratis</span>
                      <span class="font-weight-bold" v-else>&nbsp;{{ currency(_order.delivery.cost) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="subtitle-2">
                      <div :class="'shipment-' + getDeliveryLastRecord.status" v-if="isDeliveryStatusCompleted()">
                        {{ getDeliveryStatusTitle(getDeliveryLastRecord.status) }} el {{ dateFormat(getDeliveryLastRecord.creation_date, 'D MMM YYYY') }}
                      </div>
                      <div class="grey--text text--darken-1" v-else>
                        <span v-if="_order.delivery.delivery_type === 'collect-in-store'">
                          Retira a partir del {{ dateFormat(addDaysToCurrentDate(_order.delivery.delivery_days), 'D MMM YYYY') }}
                        </span>
                        <span v-else>
                          Llega el {{ dateFormat(addDaysToCurrentDate(_order.delivery.delivery_days), 'D MMM YYYY') }} a tu dirección
                        </span>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="section-title px-2">Productos comprados</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="py-0 px-0">
              <list-image-item-container class="card-border-top" v-for="(product, index) in _order.products" :key="'order_product' + index">
                <template v-slot:image>
                  <div class="product-image-container mx-xl-2 mx-lg-2 mx-md-2 mx-sm-2 mx-1" @click="goToProductDetail(product.slug)">
                    <v-img class="product-image" :src="getOrderProductCoverImage(index)" aspect-ratio="1"></v-img>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-1 pt-2">
                    <div class="text--primary text-left font-weight-light text-lowercase product-title first-capital-letter mt-1">
                      {{product.name}}
                      <span v-if="!!product.variant">&nbsp;({{product.variant.name}})</span>
                    </div>
                    <div class="headline label-price text-left font-weight-medium mt-1">{{ getOrderProductCost(index) }}</div>
                    <div class="text-left product-subtitle body-2 grey--text text--darken-1 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1">{{ product.brand }}</div>
                    <div class="text-left caption pt-1" v-if="product.formula">
                      <span v-for="(formula, index) in product.formula" :key="'product_formula_' + index">
                        <span>{{ getFormulaItemName(formula.name) }}:</span>
                        <span class="grey--text text--darken-2">&nbsp;{{ formula.value }} </span>
                      </span>
                    </div>
                    <div class="text-left body-2 grey--text text--darken-4 mt-xl-1 mt-lg-1 mt-md-1 mt-sm-1 mt-1">
                      {{ product.quantity }}
                      <span v-if="product.quantity == 1">Unidad</span>
                      <span v-else>Unidades</span>
                    </div>
                  </div>
                </template>
              </list-image-item-container>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="pl-xl-3 pl-lg-3 pl-md-3" xl="4" lg="4" md="4" sm="12" cols="12">
          <v-card class="mx-auto" outlined>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="section-title">Resumen del pedido</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-left px-0">
              <v-row no-gutters class="px-4 pt-1 pb-1">
                <v-col>
                  Producto
                </v-col>
                <v-col class="text-right grey--text text--darken-3">
                  {{ getOrderProductsCost }}
                </v-col>
              </v-row>
              <v-row no-gutters class="px-4 pb-1">
                <v-col>
                  Envío
                </v-col>
                <v-col class="text-right grey--text text--darken-3">
                  <span class="green--text text--darken-2" v-if="_order.delivery.cost === 0">&nbsp;Gratis</span>
                  <span v-else>{{ currency(_order.delivery.cost) }}</span>
                </v-col>
              </v-row>
              <v-divider class="mt-3 mb-1 mx-4"></v-divider>
              <v-row no-gutters class="px-4 mt-3 font-weight-bold">
                <v-col>
                  Total
                </v-col>
                <v-col class="text-right grey--text text--darken-3">
                  {{ getOrderCost }}
                </v-col>
              </v-row>
            </v-card-text>
            <div v-if="$vuetify.breakpoint.smAndUp">
              <v-divider></v-divider>
              <v-toolbar flat dense color="#F9F9F9">
                <v-toolbar-title class="section-title">Pago</v-toolbar-title>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="text-left py-0 px-0">
                <v-list-item class="text-left mx-1" flat>
                  <v-list-item-avatar>
                    <v-icon class="blue" dark>
                      mdi-credit-card
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content three-line>
                    <v-row no-gutters class="px-4 py-2">
                      <v-col class="grey--text text--darken-3 font-weight-bold pb-1" cols="12">
                        {{ getOrderCost }}
                      </v-col>
                      <v-col class="date-approved grey--text text--darken-3 pb-1" cols="12" v-if="_order.payment.date_approved">
                        Aprobado el {{ dateFormat(_order.payment.date_approved, 'D MMM YYYY') }}
                      </v-col>
                      <v-col :class="'payment-' + _order.payment.status" cols="12">
                        {{ getPaymentStatus(_order.payment.status) }}
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
                <v-row no-gutters class="px-4 pb-5" v-if="statusCanRetryPayment(_order.payment.status)">
                  <v-col cols="12">
                    <v-btn class="text-none" block height="42" color="blue darken-1" elevation="0" dark @click="retry(_order)" >
                      Reintentar pago
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <div v-else>
    <checkout-loader></checkout-loader>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ListImageItemContainer from '@/components/List/ListImageItemContainer'
import CheckoutLoader from '@/loaders/CheckoutLoader'
import { dateFormat, currency } from '@/shared/format'
import { addDaysToCurrentDate } from '@/shared/date'
import { getDeliveryTypeName, deliveryIsFree, getDeliveryStatusTitle, DELIVERY_STATUS_DELIVERED, DELIVERY_STATUS_RETURNED } from '@/shared/delivery'
import { getFormulaItemName } from '@/shared/formula'
import { getPaymentStatus, statusCanRetryPayment } from '@/shared/payment'

export default {
  mixins: [navigationMixin],
  components: {
    ListImageItemContainer,
    CheckoutLoader
  },
  data () {
    return {
      dateFormat,
      currency,
      addDaysToCurrentDate,
      getDeliveryTypeName,
      deliveryIsFree,
      getFormulaItemName,
      getPaymentStatus,
      statusCanRetryPayment,
      getDeliveryStatusTitle
    }
  },
  computed: {
    ...mapState('order', ['_order']),
    ...mapGetters('order', ['getOrderProductsCost', 'getOrderProductCoverImage', 'getOrderProductCost', 'getOrderCost', 'getDeliveryLastRecord'])
  },
  methods: {
    ...mapActions('order', ['getOrder']),
    goToProductDetail (slug) {
      this.goToRouteByName('Product-detail', { slug })
    },
    retry (order) {
      window.location.href = order.payment_url
    },
    shipmentDetail (order) {
      this.goToRouteByName('Shipment', { id: order.order_id })
    },
    isDeliveryStatusCompleted () {
      const record = this.getDeliveryLastRecord

      return record && (record.status === DELIVERY_STATUS_DELIVERED || record.status === DELIVERY_STATUS_RETURNED)
    }
  },
  mounted () {
    this.getOrder(this.$route.params.id)
  }
}
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .border-top{
    border-top: 1px solid;
    border-color: rgba(0, 0, 0, 0.12);
  }
  .list-title {
    color: #000000DE;
  }
  .product-image {
    width: 135px;
    height: 135px;
    border-radius: 0.25rem;
  }
  .product-image-container {
    cursor: pointer;
    position: relative;
    width: 135px;
    height: 135px;
    border-radius: 0.25rem;
  }
  .product-title{
    font-size: 1.25em;
  }
  .shipment-detail-link {
    color: #3483fa;
    cursor:pointer;
    font-size:13px;
    font-weight:600;
  }
  .date-approved {
    font-size: 13px;
  }
  .shipment-delivered {
    color: #388E3C;
    font-weight: 500;
  }
  .shipment-returned {
    color: #F57C00;
    font-weight: 500;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .product-image {
      width: 6.875rem;
      height: 6.875rem;
    }
    .product-image-container {
      position: relative;
      width: 6.875rem;
      height: 6.875rem;
    }
    .product-title{
      font-size: 1.063rem;
      line-height: 1.125rem;
    }
    .product-subtitle{
      font-size: 0.813rem !important;
      line-height: 1rem;
    }
    .label-price{
      font-size: 1.375rem !important;
    }
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .product-title{
      font-size: 0.938rem;
    }
  }
</style>
